import { Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const BankOfferHint: FC = () => {
  const theme = useTheme();

  return (
    <Typography
      component='span'
      sx={{
        display: 'inline-block',
        marginTop: '16px',
        fontSize: '16px',
        textAlign: 'left',
        color: theme.palette.primary.main,
      }}
    >
      <FormattedMessage id='my_credit_cards.bank_offer_hint' />
    </Typography>
  );
};
